//Use this file to declare constants.

export const PRODUCT_CATALOG_API_DOMAIN_URL = 'https://displaycatalog.mp.microsoft.com/v7/products';
export const MANAGE_REDIRECT_URL = 'https://accounts.microsoft.com/services';
export const TRIAL_REALM = 'trial';
export const INACTIVE_REALMS_PAGINATION_LIMIT = 5;
export const CLOSE_ICON = '/content/dam/minecraftnet/minecraft/onestorewallet/images/close.png';
export const MOBILE_VIEW = 'mobile';
export const DEFAULT_REALM_NAME = 'My Realm';
export const NEXT_AVAILABLE_API = '/realms/nextavailable';

export const alertIconList: { [Key: string]: string } = {
  green: '/content/dam/minecraftnet/minecraft/onestorewallet/images/alert_green.png',
  blue: '/content/dam/minecraftnet/minecraft/onestorewallet/images/alert_blue.png',
  yellow: '/content/dam/minecraftnet/minecraft/onestorewallet/images/alert_yellow.png',
  red: '/content/dam/minecraftnet/minecraft/onestorewallet/images/alert_red.png'
};

export enum RealmStore {
  Legacy = 'Legacy',
  OneStore = 'OneStore',
  Internal = 'Internal',
  Support = 'Support'
}
export enum PageList {
  WalletAndRealms = 'walletAndRealms',
  AddNewRealm = 'addNewRealm',
  TransferSubscription = 'transferSubscription',
  ReactivateRealm = 'reactivateRealm',
  JavaSubscription = 'javaSubscription'
}
